import React from "react";
import { motion } from "framer-motion";

function Experience() {
  // const projectContainer = {
  //   hidden: { opacity: 0 },
  //   show: {
  //     opacity: 1,
  //     transition: {
  //       staggerChildren: 0.1,
  //       delayChildren: 0.2,
  //     },
  //   },
  // };
  // const projectAnimation = {
  //   hidden: { opacity: 0, y: 20 },
  //   show: {
  //     opacity: 1,
  //     y: 0,
  //     transition: {
  //       duration: 0.5,
  //     },
  //   },
  // };
  // console.log(projects);
  return (
    <div className="mb-16 lg:mb-18 mt-12 lg:mt-20">
      <motion.h2
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.5 }}
        className="text-3xl md:text-5xl font-bold text-my-purple-400 text-center mb-0 lg:mb-8"
      >
        &lt;<span className="text-gray-900 dark:text-white">Experience</span>
        &#47;&gt;
      </motion.h2>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="container flex justify-center items-top gap-12 flex-wrap pt-10"
      >
      <ol class="relative border-s border-my-purple-800 dark:border-my-purple-400">                  
          <li class="mb-10 ms-4">
              <div class="absolute w-3 h-3 bg-my-purple-400 rounded-full mt-1.5 -start-1.5 border border-white dark:border-gray-900 dark:bg-my-purple-800"></div>
              <time class="mb-1 text-sm font-normal leading-none text-my-purple-400 dark:text-my-purple-800">May 2024 - Present</time>
              <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Trainee Software Engineer</h3>
              <p class="mb-4 text-base font-normal text-gray-500 dark:text-gray-400">LinearSix</p>
          </li>
          <li class="mb-10 ms-4">
              <div class="absolute w-3 h-3 bg-my-purple-400 rounded-full mt-1.5 -start-1.5 border border-white dark:border-gray-900 dark:bg-my-purple-800"></div>
              <time class="mb-1 text-sm font-normal leading-none text-my-purple-400 dark:text-my-purple-800">November 2023 - April 2024</time>
              <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Intern Software Engineer</h3>
              <p class="text-base font-normal text-gray-500 dark:text-gray-400">LinearSix</p>
          </li>
          <li class="mb-10 ms-4">
              <div class="absolute w-3 h-3 bg-my-purple-400 rounded-full mt-1.5 -start-1.5 border border-white dark:border-gray-900 dark:bg-my-purple-800"></div>
              <time class="mb-1 text-sm font-normal leading-none text-my-purple-400 dark:text-my-purple-800">November 2019 - April 2020</time>
              <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Product Associate</h3>
              <p class="text-base font-normal text-gray-500 dark:text-gray-400">Innodata Lanka</p>
          </li>
      </ol>
      </motion.div>
    </div>
  );
}

export default Experience;